import React, { FC, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, RouteComponentProps } from 'react-router-dom'
import routes from 'src/routes'
import { get, ON_DEMAND_APIS } from '../../../apis/onDemandApi'
import { getAreaOfInterests, setPageTitle, setPreviousPage } from '../../../ducks/onDemand'
import posterThumbnail from '../../../images/gallerium/onDemand/poster-thumbnail.png'
import videoThumbnail from '../../../images/gallerium/onDemand/video-thumbnail.png'
import { Loader } from '../../shared/Loader'
import { AbstractSearch } from '../AbstractSearch'
import { AbstractType } from '../PresentationContainer/PresentationContainer'

const pageTitleSwitch = {
  oral: 'Oral Presentations',
  poster: 'E-Poster Presentations',
}

const AreaOfInterestSelectionZ: FC<RouteComponentProps> = ({ location }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState<boolean>(false)
  const { areaOfInterests, areaOfInterestsFetched } = useSelector((state) => state.onDemand)

  const submissionType: AbstractType['submission_type'] = location.pathname === routes.onDemandPoster ? 'poster' : 'oral'

  const thumbnails = {
    [routes.onDemandOral]: videoThumbnail,
    [routes.onDemandPoster]: posterThumbnail,
  }

  const fetchAOI = useCallback(() => {
    setLoading(true)
    get(
      ON_DEMAND_APIS.AREA_OF_INTERESTS,
      (data) => {
        setLoading(false)
        dispatch(getAreaOfInterests(data.categories))
      },
      (error) => {
        setLoading(false)
        console.error(error)
      }
    )
  }, [dispatch])

  useEffect(() => {
    dispatch(setPreviousPage(routes.onDemand))
  }, [dispatch])

  useEffect(() => {
    const pageTitle = pageTitleSwitch[submissionType]
    dispatch(setPageTitle(pageTitle))
  }, [dispatch, location.pathname, submissionType])

  useEffect(() => {
    if (!areaOfInterestsFetched) {
      fetchAOI()
    }
  }, [areaOfInterestsFetched, dispatch, fetchAOI])

  return (
    <Loader loading={loading}>
      <div>
        <AbstractSearch submissionType={submissionType} />
        <div className="grid-container">
          {areaOfInterests.map((area) => (
            <Link key={area} to={`${location.pathname}/${area}`} className="card-thumbnail">
              <img src={thumbnails[location.pathname]} width="100%" alt="thumbnail" />
              <span>{area}</span>
            </Link>
          ))}
          <div className="spacer-100"></div>
          <div className="spacer-100"></div>
          <div className="spacer-100"></div>
        </div>
      </div>
    </Loader>
  )
}

export const AreaOfInterestSelection = React.memo(AreaOfInterestSelectionZ)
